import { render, staticRenderFns } from "./MultiDoughnutChart.vue?vue&type=template&id=f76e9fc0&"
import script from "./MultiDoughnutChart.vue?vue&type=script&lang=js&"
export * from "./MultiDoughnutChart.vue?vue&type=script&lang=js&"
import style0 from "./MultiDoughnutChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports